import { ReactNode, createContext } from "react";

interface CollapsibleCardColorContextValue {
  color?: string;
}

const CollapsibleCardColorContext = createContext<
  CollapsibleCardColorContextValue | undefined
>(undefined);

const CollapsibleCardColorProvider = ({
  children,
  color,
}: {
  children: ReactNode;
  color?: string;
}) => {
  return (
    <CollapsibleCardColorContext.Provider value={{ color }}>
      {children}
    </CollapsibleCardColorContext.Provider>
  );
};

export { CollapsibleCardColorContext, CollapsibleCardColorProvider };
